import React, { createContext, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import store from '../store/store';
import { newTab } from './events/newTab';
import { loadTab } from './events/loadTab';
import { focusTab } from './events/focusTab';
import { closeTab } from './events/closeTab';
import { clearBreadcrumb } from '../store/workspaces/breadcrumb/actions';

const InteractionContext = createContext();

export const useInteraction = () => {
  return useContext(InteractionContext);
};

const InteractionProvider = ({ children }) => {

  const isModalOpen = () => {
    const workspaces = store.getState().workspaces.instances; // ToDo: refactor workspaces state
    const workspace = workspaces.find(workspace => workspace.isActive === true);
    const modals = workspace.modals;
    const isOpen = Object.values(modals).some(modal => modal?.isOpen === true);
    return isOpen;
  };

  const handleMouseDown = async (event) => {
    const { detail } = event;
    const { modifiers } = detail;

    if(modifiers){
      if (modifiers.ctrl && modifiers.shift){
        await loadTab(detail);
        await focusTab(store.getState().workspaces.instances.length - 1);
        return;
      }
      if(modifiers.ctrl){
        await loadTab(detail);
        return;
      } 
    }

    if(detail.event.ctrlKey && detail.event.shiftKey){
      await loadTab(detail);
      await focusTab(store.getState().workspaces.instances.length - 1);
      return;
    }

    if (detail.event.ctrlKey) {
      await loadTab(event.detail);
      return;
    }
  };

  const handleKeyDown = async (event) => {
    if (event.altKey && event.key === 'n') {
      if (!isModalOpen()) {
        await newTab();
        const { instances } = store.getState().workspaces;
        const index = instances.length - 1;
        await focusTab(index);
        store.dispatch(clearBreadcrumb());
      }
    }
    if (event.altKey && event.key === 'Delete') {
      await closeTab();
    }
    if (event.altKey && event.key.match(/[0-9]/)) {
      if (!isModalOpen()) {
        const getIndex = eventKey => eventKey === 0 ? 9 : eventKey - 1;
        await focusTab(getIndex(parseInt(event.key)));
      }
    }
  };

  useEffect(() => {
    const onMouseDown = async (event) => {
      await handleMouseDown(event);
    };

    const onKeyDown = async (event) => {
      await handleKeyDown(event);
    };

    window.addEventListener('custom-mousedown', onMouseDown);
    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('custom-mousedown', onMouseDown);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [handleMouseDown, handleKeyDown]);

  const contextValue = {
    handleMouseDown,
    handleKeyDown,
  };

  return (
    <InteractionContext.Provider value={contextValue}>
      {children}
    </InteractionContext.Provider>
  );
};

InteractionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InteractionProvider;
